import { LANG_CODE } from './consts';

export const formatAmount = (amount: number | string) => {
  const roundedAmount = Math.round(Number(amount));
  return roundedAmount.toLocaleString(LANG_CODE.SV_SE);
};
